/**
 * @generated SignedSource<<5e4e8e9ec05e6571ecefb5c1bd1e5cbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "proposeCommunityTrade",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProposeCommunityTradeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProposeCommunityTradeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "28bf4accb8828f700b3191546f5f0025",
    "id": null,
    "metadata": {},
    "name": "ProposeCommunityTradeMutation",
    "operationKind": "mutation",
    "text": "mutation ProposeCommunityTradeMutation(\n  $input: CommunityTradeProposal!\n) {\n  proposeCommunityTrade(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "e9882eebdcc5ae1665aa07374e80701d";

module.exports = node;
